<!--
 * @Description: 加油券卡密组件
 * @Author: yl
 * @Date: 2021-06-10 09:57:07
 * @LastEditTime: 2021-06-16 14:03:15
 * @LastEditors: yl
-->
<template>
    <div class="gasCouponKeys bh bv bstart">
        <div v-if="!isNoShowLabel" class="fz_34 label c_black">卡密信息</div>
        <div v-if="code" class="fz_30 label c_333 bh bbetween keyArea"
            style="font-family: PingFang SC, PingFang SC-Bold;">
            卡密：{{code.replace(/\D/gi, "").replace(/....(?!$)/g, '$& ')}}
            <van-image class="btn" :src="require('@/assets/imges/user/copy.png')" v-on:click.native="copy(code)">
                <template v-slot:loading>
                    <van-loading type="spinner" size="20" />
                </template>
            </van-image>
        </div>
        <div class="fz_28 c_333">请复制卡密,并扫码关注下方二维码到“<span style='color: #C30D23;'>油总管四川</span>”公众号 【卡劵兑换】里面兑换加油卡劵</div>
        <div class="QRCode bv bc">
            <van-image class="img" :src="require('@/assets/imges/user/yzgQRCode.png')">
                <template v-slot:loading>
                    <van-loading type="spinner" size="20" />
                </template>
            </van-image>
            <span class="fz_28 c_666 tips">【长按识别二维码】</span>
        </div>
    </div>
</template>

<script>
import VueClipboard from "vue-clipboard2";
import Vue from "vue";
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
export default {
    components: {},
    name: "",
    props: {
        code: null,
        isNoShowLabel: Boolean
    },
    data() {
        return {
        };
    },
    methods: {
        copy(val) {
            // 方法一
            // var input = document.createElement("input");// 直接构建input
            // input.value = val;// 设置内容
            // document.body.appendChild(input);// 添加临时实例
            // input.select();// 选择实例内容
            // document.execCommand("Copy");// 执行复制
            // document.body.removeChild(input);// 删除临时实例
            // this.toast.success("复制成功");
            // 方法二
            const me = this;
            me.$copyText(val).then(
                function(e) {
                    me.toast.success("复制成功");
                },
                function(e) {
                    console.log(e);
                }
            );
        }
    },
    mounted() {
        // console.log(this.code)
    }
};
</script>

<style scoped lang="scss">
.gasCouponKeys {
    .label {
        width: 100%;
    }
    .keyArea {
        padding-bottom: 27px;
        .btn {
            width: 134px;
            height: 56px;
            // margin-left: 77px;
        }
    }
    // 二维码
    .QRCode {
        padding: 30px 0;
        .img {
            width: 400px;
        }
        .tips {
            padding-top: 16px;
        }
    }
}
</style>